/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import PropTypes from "prop-types";
import styles from "./SelectSettingsForm.module.css";
import { TextField } from "@material-ui/core";

const SelectSettingsForm = ({ languages, namespaces, config, onSelect, filterType, setFilterType, promptTypeList }) => {
	const handleLanguageSelect = (event) => {
		const newConfig = { ...config, language: event.target.value };
		onSelect(newConfig);
	};

	const handleNamespaceSelect = (event) => {
		const newConfig = { ...config, namespace: event.target.value };
		onSelect(newConfig);
	};

	return (
		<>
			<div style={{ gap: 15 }} className={styles.content}>
				<div className={styles.textFieldDiv}>
					<TextField
						id="language"
						select
						label="Language"
						value={config.language}
						size="small"
						margin="dense"
						fullWidth
						className="my-0"
						onChange={handleLanguageSelect}
						SelectProps={{
							native: true,
						}}
					>
						{languages?.map((language) => (
							<option key={language} value={language}>
								{language}
							</option>
						))}
					</TextField>
				</div>
				<div className={styles.textFieldDiv}>
					<TextField
						id="namespace"
						select
						label="Namespace"
						value={config.namespace}
						size="small"
						margin="dense"
						className="my-0"
						fullWidth
						onChange={handleNamespaceSelect}
						SelectProps={{
							native: true,
						}}
					>
						{namespaces?.map((namespace) => (
							<option key={namespace} value={namespace}>
								{namespace}
							</option>
						))}
					</TextField>
				</div>
				<div className={styles.textFieldDiv}>
					<TextField
						id="typeTextField"
						select
						label="Type"
						value={filterType}
						className="my-0"
						size="small"
						margin="dense"
						fullWidth
						onChange={(e) => {
							setFilterType(e.target.value);
						}}
						SelectProps={{
							native: true,
						}}
					>
						{["All", ...Object.values(promptTypeList)].map((option) => (
							<option key={option} value={option}>
								{option}
							</option>
						))}
					</TextField>
				</div>
			</div>
		</>
	);
};

SelectSettingsForm.propTypes = {
	languages: PropTypes.arrayOf(PropTypes.string).isRequired,
	namespaces: PropTypes.arrayOf(PropTypes.string).isRequired,
	config: PropTypes.shape({
		language: PropTypes.string,
		namespace: PropTypes.string,
	}).isRequired,
	onSelect: PropTypes.func.isRequired,
	filterType: PropTypes.string,
	setFilterType: PropTypes.func.isRequired,
	promptTypeList: PropTypes.object,
};

export default SelectSettingsForm;
